import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { cloneDeep } from 'lodash';
import {
  changePasswordValidationSchema,
  signInValidationSchema,
  signUpValidationSchema,
} from '~/modules/auth/validationSchema.ts';
import { initialValuesChangePassword, initialValuesSignUp } from '~/modules/auth/initialValues.ts';
import { TChangePasswordForm, TSignInForm, TSignUpForm } from '~/modules/auth/types.ts';
import { getDecryptedCookieValue } from '~/helpers/cookieCrypto';
import { MANAGER_USERNAME_COOKIE, USERNAME_COOKIE } from '../constants';

export const useSingUpForm = () => {
  const resolver: Resolver<TSignUpForm> = yupResolver(signUpValidationSchema, {
    abortEarly: false,
  }) as Resolver<TSignUpForm>;

  const form = useForm<TSignUpForm>({
    defaultValues: cloneDeep(initialValuesSignUp),
    resolver,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
  });

  return form;
};

export const useChangePasswordForm = () => {
  const resolver: Resolver<TChangePasswordForm> = yupResolver(changePasswordValidationSchema, {
    abortEarly: false,
  }) as Resolver<TChangePasswordForm>;

  const form = useForm<TChangePasswordForm>({
    defaultValues: cloneDeep(initialValuesChangePassword),
    resolver,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
  });

  return form;
};

export const useSingInForm = (isManager?: boolean) => {
  const resolver: Resolver<TSignInForm> = yupResolver(signInValidationSchema, {
    abortEarly: false,
  }) as Resolver<TSignInForm>;
  const cookieName = isManager ? MANAGER_USERNAME_COOKIE : USERNAME_COOKIE;
  const username = getDecryptedCookieValue(cookieName) || '';

  const initialValues = {
    username: username,
    password: '',
  };

  const form = useForm<TSignInForm>({
    defaultValues: cloneDeep(initialValues),
    resolver,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
  });

  return form;
};
